import store from '../store'

export default [
  {
    path: '/relatorios/regiao',
    name: 'relatorios-regiao-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getEstados')
      await store.dispatch('getRegioes')
      await store.commit('setRelatorio', [])
      next()
    },
    meta: {
      title: 'Relatórios de região',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao'
      )
    }
  },
  {
    path: '/relatorios/regiao/cliente/ativo/exibir',
    name: 'relatorios-regiao-cliente-ativo-show',
    beforeEnter: async (to, from, next) => {
      const { estado, regiao = null } = store.getters.variaveis
      await store.dispatch('getEstado', {
        id: Number(estado)
      })
      if (regiao) {
        await store.dispatch('getRegiao', {
          id: Number(regiao)
        })
      }
      await store.dispatch('getRelatorioRegiaoClienteAtivo', {
        estado,
        regiao
      })
      next()
    },
    meta: {
      isChart: false,
      isOpcionalValue: false,
      isIndustry: false,
      title: 'Relatório de clientes ativos (por região)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao/filtros/cliente/ativo'
      )
    }
  },
  {
    path: '/relatorios/regiao/geolocalizacao/exibir',
    name: 'relatorios-regiao-geolocalizacao-show',
    beforeEnter: async (to, from, next) => {
      const { estado, regiao = null } = store.getters.variaveis
      await store.dispatch('getEstado', {
        id: Number(estado)
      })
      if (regiao) {
        await store.dispatch('getRegiao', {
          id: Number(regiao)
        })
      }
      await store.dispatch('getRelatorioRegiaoGeolocalizacao', {
        estado,
        regiao
      })
      next()
    },
    meta: {
      isChart: false,
      isOpcionalValue: false,
      isIndustry: false,
      title: 'Relatório de clientes (por região)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao/filtros/geolocalizacao'
      )
    }
  },
  {
    path: '/relatorios/regiao/cliente/inativo/exibir',
    name: 'relatorios-regiao-cliente-inativo-show',
    beforeEnter: async (to, from, next) => {
      const { estado, regiao = null } = store.getters.variaveis
      await store.dispatch('getEstado', {
        id: Number(estado)
      })
      if (regiao) {
        await store.dispatch('getRegiao', {
          id: Number(regiao)
        })
      }
      await store.dispatch('getRelatorioRegiaoClienteInativo', {
        estado,
        regiao
      })
      next()
    },
    meta: {
      isChart: false,
      isOpcionalValue: false,
      isIndustry: false,
      title: 'Relatório de clientes inativos (por região)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao/filtros/cliente/inativo'
      )
    }
  },
  {
    path: '/relatorios/regiao/cidade/exibir',
    name: 'relatorios-regiao-cidade-show',
    beforeEnter: async (to, from, next) => {
      const { estado, regiao = null } = store.getters.variaveis
      await store.dispatch('getEstado', {
        id: Number(estado)
      })
      if (regiao) {
        await store.dispatch('getRegiao', {
          id: Number(regiao)
        })
      }
      await store.dispatch('getRelatorioRegiaoCidade', {
        estado,
        regiao
      })
      next()
    },
    meta: {
      isChart: false,
      isOpcionalValue: true,
      isIndustry: false,
      isShowSumValue: true,
      sumValueType: 'cliente',
      title: 'Relatório de municípios atendidos (por região)',
      opcionalCondition: item => item['__meta__'].clientes_count > 0,
      showSumValue: array =>
        array.reduce(
          (acum, item) => (acum += Number(item['__meta__'].clientes_count)),
          0
        ),
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao/filtros/municipio'
      )
    }
  },
  {
    path: '/relatorios/regiao/lactacao/exibir',
    name: 'relatorios-regiao-lactacao-show',
    beforeEnter: async (to, from, next) => {
      const { estado, regiao = null, inicial, final } = store.getters.variaveis
      await store.dispatch('getEstado', {
        id: Number(estado)
      })
      if (regiao) {
        await store.dispatch('getRegiao', {
          id: Number(regiao)
        })
      }
      await store.dispatch('getRelatorioRegiaoLactacao', {
        estado,
        regiao,
        inicial,
        final
      })
      next()
    },
    meta: {
      isChart: true,
      isOpcionalValue: false,
      isIndustry: false,
      title: 'Relatório de animais em lactação (por região)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao/filtros/lactacao'
      )
    }
  },
  {
    path: '/relatorios/regiao/valor/leite/exibir',
    name: 'relatorios-regiao-valor-leite-show',
    beforeEnter: async (to, from, next) => {
      const { estado, regiao = null, inicial, final } = store.getters.variaveis
      await store.dispatch('getEstado', {
        id: Number(estado)
      })
      if (regiao) {
        await store.dispatch('getRegiao', {
          id: Number(regiao)
        })
      }
      await store.dispatch('getRelatorioRegiaoValorPagoLeite', {
        estado,
        regiao,
        inicial,
        final
      })
      next()
    },
    meta: {
      isChart: true,
      isOpcionalValue: false,
      isIndustry: false,
      title: 'Relatório de valor pago no leite (por região)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao/filtros/leite'
      )
    }
  },
  {
    path: '/relatorios/regiao/producao/exibir',
    name: 'relatorios-regiao-producao-show',
    beforeEnter: async (to, from, next) => {
      const { estado, regiao = null, inicial, final } = store.getters.variaveis
      await store.dispatch('getEstado', {
        id: Number(estado)
      })
      if (regiao) {
        await store.dispatch('getRegiao', {
          id: Number(regiao)
        })
      }
      await store.dispatch('getRelatorioRegiaoProducao', {
        estado,
        regiao,
        inicial,
        final
      })
      next()
    },
    meta: {
      isChart: true,
      isOpcionalValue: false,
      isIndustry: false,
      title: 'Relatório de produção estimada (por região)',
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }],
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/regiao/filtros/producao'
      )
    }
  }
]
